module.exports = __webpack_public_path__ + "static/profilepic_alexandra-209c0a73619c7931f5eff78c13356516.jpeg";